/**
 * Reusable validation error display component
 * @module FormFields/ValidationErrorDisplay
 */

import { memo } from 'react';

/**
 * Props for ValidationErrorDisplay component
 */
export interface ValidationErrorDisplayProps {
  /** Error message to display */
  message: string;
  /** Unique ID for the error element */
  id: string;
}

/**
 * Display validation error for a form field
 * Shows error icon and message with proper accessibility
 * 
 * @param props - Component props
 * @param props.message - Error message to display
 * @param props.id - Unique ID for the error element
 * @returns ValidationErrorDisplay component
 */
export const ValidationErrorDisplay = memo<ValidationErrorDisplayProps>(({ message, id }) => (
  <div className="error-description">
    <ul id={id} className='my-0!'>
      <li>
        <img
          src="/assets/images/errorCircleSmall.svg"
          alt="Error icon"
          width="14"
          height="14"
        />
        <span className="screenreader-only">{message}</span> {message}
      </li>
    </ul>
  </div>
));

ValidationErrorDisplay.displayName = 'ValidationErrorDisplay';
